module.exports = __webpack_public_path__ + "static_pc/img/4.9799a58a.png";